export const MediaType = {
    SESSION: 'session',
    PRESENTATION: 'presentation'
};
